import { hookFromSubject } from "react-rxjs-easy";
import { BehaviorSubject } from "rxjs";

export const setPopoverTargetSubject = new BehaviorSubject(() => () => null);
export const useSetPopoverTarget = hookFromSubject(setPopoverTargetSubject);
